module.exports = __webpack_public_path__ + "img/figure-29.0cc12658.png";